/* eslint-disable no-param-reassign */
import {
  ApplicationInsights,
  DistributedTracingModes,
  SeverityLevel,
} from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import env from './utils/getEnv';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: env.appInsightsConnectionString || '',
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    distributedTracingMode: DistributedTracingModes.W3C,
    correlationHeaderExcludedDomains: [
      '*.google-analytics.com',
      '*.google.com',
      'atlas.microsoft.com',
      '*.in.applicationinsights.azure.com',
    ],
    // Dual copies of applicationinsights-core-js (root vs nested under
    // react-js) make ReactPlugin fail assignability to ITelemetryPlugin.
    extensions: [reactPlugin as never],
  },
});

if (env.appInsightsConnectionString) {
  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer(envelope => {
    envelope.tags = envelope.tags || {};
    envelope.tags['ai.cloud.role'] = 'digital-service-web-portal';
    envelope.data = envelope.data || {};
    envelope.data.appName = 'digital-service-web-portal';
  });
}

export const logInfo = (
  message: string,
  properties?: Record<string, string>,
): void => {
  if (!env.appInsightsConnectionString) return;
  appInsights.trackTrace({
    message,
    severityLevel: SeverityLevel.Information,
    properties,
  });
};

export const logWarn = (
  message: string,
  properties?: Record<string, string>,
): void => {
  if (!env.appInsightsConnectionString) return;
  appInsights.trackTrace({
    message,
    severityLevel: SeverityLevel.Warning,
    properties,
  });
};

export const logError = (
  message: string,
  error?: Error,
  properties?: Record<string, string>,
): void => {
  if (!env.appInsightsConnectionString) return;
  appInsights.trackTrace({
    message,
    severityLevel: SeverityLevel.Error,
    properties: { ...properties, stack: error?.stack ?? '' },
  });
};

export { reactPlugin, appInsights };
